import { action, observable } from 'mobx';
import { api } from '../config';

// Helpers
import { promptUser } from '../helpers/helpers.js';

// Components
import SessionStore from './SessionStore';
import SettingsStore from './SettingsStore';
import ScheduleStore from './ScheduleStore';

let obx = observable({
  examSlots: null,
  resetExamSlots: action(function() {
    obx.examSlots = null;
  }),
  exams: [],
  // Reset exam data
  resetExams: action(function(){
    obx.exams = [];
  }),
  // Get student exams
  getStudentExams: action(function(getFullConfig) {
    SessionStore.startLoading('Loading…', 'StudentExams');
    obx.resetExams();

    api.get(`/install/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/enrollments/${SessionStore.userData.enrollmentSid}/exams`)
      .then(response => {
        obx.exams = response.data.results;

        if(response.data.results.length === 0) {
          SessionStore.hideMsg = true;
        } else {
          SessionStore.hideMsg = false;
        }

        if(getFullConfig) {
          obx.exams.forEach(exam => {
            obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
          })
        }

        SessionStore.finishLoading('StudentExams');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),

  /**
   * Get student exams, ordered and grouped by status
   * 
   * @function getOrderedStudentExams
   * @param {boolean} getFullConfig
   */
  getOrderedStudentExams: action((getFullConfig, sessionSid = null) => {
    SessionStore.startLoading('Loading…', 'getOrderedStudentExams');

    api.get(`/install/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/enrollments/${SessionStore.userData.enrollmentSid}/exams/ordered`)
      .then(response => {
        obx.orderedExams = response.data.exams;
        const { active, closed, upcoming } = response.data.exams;

        if(active.length === 0 && closed.length === 0 && upcoming.length === 0) {
          SessionStore.hideMsg = true;
        } else {
          SessionStore.hideMsg = false;
        }

        if(getFullConfig) {
          active.forEach(exam => {
            obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
          });

          closed.forEach(exam => {
            obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
          });

          upcoming.forEach(exam => {
            obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
          });
        }

        // If a sessionSid was passed in we just attempted to scheduled a session. Show a toast with schedule status 
        if (sessionSid) {
          active.forEach(exam => {
            if (exam.examSession.sid === sessionSid && exam.examSession.schedulingModule === 'register-blast') {
                if (exam.examSession.status === 'Scheduled') {
                  SessionStore.showToaster('Session scheduled successfully', 'success');
                }
            } else if (exam.examSession.sid === sessionSid && exam.examSession.status !== 'Scheduled') {
                SessionStore.showToaster('Session was not scheduled', 'warning');
              }
          })
          ScheduleStore.resetData();
        }

        SessionStore.finishLoading('getOrderedStudentExams');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get student exam configuration
  getStudentExamConfiguration: action(function(examSid, configurationSid, exam) {
    SessionStore.startLoading('Loading…', 'StudentExamConfiguration');

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams/${examSid}/configurations/${configurationSid}`)
      .then(response => {
        // Hold onto the session’s attempts remaining count
        // because this endpoint doesn’t take session status
        // into account
        const attemptsRemaining = exam.examSession.examConfiguration.attemptsRemaining;

        if(exam) {
          exam.examSession.examConfiguration = response.data;
          exam.examSession.examConfiguration.attemptsRemaining = attemptsRemaining;
        }

        SessionStore.finishLoading('StudentExamConfiguration');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get single proctor group
  getProctorGroup: action(function (proctorGroupSid, component) {
    SessionStore.startLoading('Loading…', 'GetProctorGroup');

    api.get(`/installs/${SessionStore.userData.installSid}/proctorGroup`)
      .then(response => {
        let proctorGroup = {};

        for(let i = 0; i < response.data.results.length; i++) {
          if(response.data.results[i].sid === proctorGroupSid) {
            proctorGroup = response.data.results[i];
          }
        }

        if(component) {
          component.setState({
            proctorGroup
          });
        }

        SessionStore.finishLoading('GetProctorGroup');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Log in as student
  impersonate: action(function(enrollmentSid, accessKey, studentWindow, userSid, integrationSid) {
    if(SessionStore.userData.integrationSid || integrationSid) {
      let integration = integrationSid;

      if(!integration) {
        integration = SessionStore.userData.integrationSid
      }

      // Access key has been provided, so launch the impersonation
      if(!studentWindow) {
        studentWindow = window.open('', '_blank');
      }

      studentWindow.location.href = `https://signon.smarterservices.com/v1/applications/smarterproctoring/impersonate?redirect=true&enrollmentSid=${enrollmentSid}&userSid=${userSid}&installIntegrationSid=${integration}&token=${SessionStore.token}`
    } else {
      // No access key provided, so it's probably an admin
      // Need to ask which integration they need
      const options = [
        {
          label: "Select an integration…",
          value: ''
        }
      ]

      SettingsStore.integrations.forEach(integration => {
        if(integration) {
          const option = {
            label: integration.name,
            value: integration.sid
          }

          options.push(option);
        }
      });

      const msg = {
        heading: "Which integration?",
        options,
        button: "Select"
      }

      const selectFunc = (integration) => {
        studentWindow = window.open('', '_blank');
        obx.impersonate(enrollmentSid, null, studentWindow, userSid, integration);
      }

      if(SettingsStore.integrations.length === 1) {
        selectFunc(SettingsStore.integrations[0].sid);
      } else {
        promptUser(msg, selectFunc);
      }
    }
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/StudentStore.js